import React, { Fragment } from 'react';

import { Ride, ICoordinates, IChangeHistory, ICompany, CanceledBy } from '../tracking/entities';
import { DriverDetailes } from '../driverDetails/driverDetailes';
import { Address } from '../address/address';
import { Status, OrderStatus, PartialTrackingStatusesSupported } from '../status/Status';
import Map from '../map/Map';

import { connect } from 'react-redux';

import gettLogo from './images/logo.png';

import styled from 'styled-components';

import { Divider } from 'antd';
import { isNil } from 'lodash';
import { withTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { Eta } from '../eta/eta';
import { IETA, IStop, RideType, StopActionType } from './entities';
import { FindStoppoint, GetDayOfTheWeekString } from '../common/utils';
import { AddressElement, IconType } from '../address/address';
import { MeetAndGreet } from '../meet/MeetAndGreet';
import { thunkPushEvent } from '../events/actions';
import { EventType } from '../events/entities';

type Props = {
    ride: Ride;
    token: string;
    thunkPushEvent: any;
    t: any;
};

class LatLngStatic {
    constructor(lat: number, lng: number) {
        this.lat = lat;
        this.lng = lng;
    }

    lat: number;
    lng: number;
}

const miliseconds = 1000;

const week = 7 * 24 * 60 * 60 * miliseconds;

const deliveryTranslationSuffix = '_delivery';

const timeOptions = { hour: 'numeric' as const, minute: 'numeric' as const, hour12: false };

const DriverDetailesContainer = styled(DriverDetailes)`
    width: 100%;
`;

// Preventing showing ETA in some statuses as it makes no sence to show it and some fleets arew sending it
const EtaUnsupportedStatuses = [
    OrderStatus.COMPLETED,
    OrderStatus.WAITING,
    OrderStatus.CANCELLED,
    OrderStatus.PENDING,
    OrderStatus.STATUS_CARE_REQ,
];

const BottomContainer = styled.div`
    position: relative;
    background-color: white;
    width: 100%;
    margin-top: -24px;
    border-radius: 24px 24px 0 0;
    box-shadow: 0 8px 16px -4px rgba(38, 50, 56, 0.2), 0 1px 1px 0 rgba(38, 50, 56, 0.04);
    padding-bottom: 10px;
`;

const LogoContainer = styled.div`
    padding: 14px 25px 22px 25px;
    border-bottom: 1px solid #f0f2f3;
`;

const LogoImg = styled.img`
    height: 38px;
`;

const DividerWrapper = styled(Divider)`
    margin: 0 0;
    padding: 0 23px;
`;

const ButtonContainer = styled.div`
    width: auto;
    margin: 0 24px;
    padding: 8px;
    height: 40px;
    border-radius: 10px;
    border: solid 1px #dfe5e7;
    font-family: 'Graphik LCG', sans-serif;
    background-color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    color: #263238;
    text-align: center;
`;

class TrackingWrapper extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    convertCoord(loc: ICoordinates) {
        let lat = 0,
            lng = 0;

        if (loc) {
            if (loc) {
                lng = loc.longitude ? loc.longitude : 0;
                lat = loc.latitude ? loc.latitude : 0;
            }
        }
        return new LatLngStatic(lat, lng);
    }

    calcCenter(origin: LatLngStatic, destination: LatLngStatic) {
        const lat = (origin.lat + destination.lat) / 2 - 0.015;
        const lng = (origin.lng + destination.lng) / 2;
        return new LatLngStatic(lat, lng);
    }

    latRad(lat) {
        var sin = Math.sin((lat * Math.PI) / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    // calculate zoom level according origin and destination
    getZoom(origin: LatLngStatic, destination: LatLngStatic) {
        const latDif = Math.abs(this.latRad(origin.lat) - this.latRad(destination.lat));
        const lngDif = Math.abs(origin.lng - origin.lng);

        const latFrac = latDif / Math.PI;
        const lngFrac = lngDif / 360;

        const lngZoom = Math.log(1 / latFrac) / Math.log(2) - 1;
        const latZoom = Math.log(1 / lngFrac) / Math.log(2);

        return Math.min(lngZoom, latZoom);
    }

    getTime(min: number) {
        let res = '';
        if (isNil(min)) {
            return res;
        }

        const { t } = this.props;
        const hours = Math.floor(min / 60);
        const minutes = Math.floor(min % 60);
        if (hours === 1) {
            res += `1 ${t('common:Hour')}`;
        } else if (hours > 1) {
            res += `${hours} ${t('common:Hours')}`;
        }
        if (minutes > 0) {
            res += ` ${minutes} ${t('common:Min')}`;
        }
        if (hours < 1 && minutes < 1) {
            return `1 ${t('common:Min')}`;
        }
        return res;
    }

    getDistance(distance: number) {
        if (isNil(distance)) {
            return '';
        }
        const km = Math.floor(distance / 1000);
        if (km > 0) {
            return `${Math.floor(distance / 1000)}km `;
        } else {
            return `${distance}m `;
        }
    }

    calcTranslationString(key: string, type: RideType | null | undefined) {
        return RideType.RIDE_TYPE_RIDER === type ? key : key + deliveryTranslationSuffix;
    }

    isToday(date: Date) {
        const now = new Date();
        return (
            date.getFullYear() === now.getFullYear() &&
            date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth()
        );
    }

    isTommorow(date: Date) {
        const now = new Date();
        return (
            date.getFullYear() === now.getFullYear() &&
            date.getDate() === now.getDate() + 1 &&
            date.getMonth() === now.getMonth()
        );
    }

    calcDateString(t: TFunction, date: Date) {
        const now = new Date();

        if (date.getTime() - now.getTime() > week) {
            return date.toLocaleDateString('en-GB');
        } else if (this.isToday(date)) {
            return t('common:Today');
        } else if (this.isTommorow(date)) {
            return t('common:Tomorrow');
        } else {
            return t('common:' + GetDayOfTheWeekString(date.getDay()));
        }
    }

    calcCanceledStatusText(t: TFunction, type: RideType | null | undefined, canceledBy: CanceledBy | null | undefined) {
        if (canceledBy == null) {
            return t(this.calcTranslationString('Cancelled', type));
        }
        let cancelatorString = t('By_admin');
        switch (canceledBy) {
            case CanceledBy.CANCELED_BY_API:
                cancelatorString = t('By_api');
                break;
            case CanceledBy.CANCELED_BY_BOOKER:
                cancelatorString = t('By_booker');
                break;
            case CanceledBy.CANCELED_BY_CC:
                cancelatorString = t('By_cc');
                break;
            case CanceledBy.CANCELED_BY_DRIVER:
                cancelatorString = type === RideType.RIDE_TYPE_RIDER ? t('By_driver') : t('By_courier');
                break;
            default:
                break;
        }
        return `${t(this.calcTranslationString('Cancelled', type))} ${cancelatorString}`;
    }

    getStatusMessage(
        t: TFunction,
        history: IChangeHistory | null | undefined,
        status: OrderStatus | null | undefined,
        type: RideType | null | undefined,
        canceledBy: CanceledBy | null | undefined,
        eta: IETA | null | undefined,
        isUntrackable: boolean
    ) {
        if (isNil(status)) {
            return null;
        }
        if (isUntrackable && status && !PartialTrackingStatusesSupported.includes(status)) {
            // In case of partial tracking showing active ride in all statuse except initial ones(routing, )
            return t(this.calcTranslationString('Active_ride', type));
        }
        switch (status) {
            case OrderStatus.ROUTING:
                return t(this.calcTranslationString('Looking_for_a_driver', type));
            case OrderStatus.REJECTED:
                return t(this.calcTranslationString('Rejected', type));
            case OrderStatus.CANCELLED:
                return this.calcCanceledStatusText(t, type, canceledBy);
            case OrderStatus.CONFIRMED:
                return t(this.calcTranslationString('Arriving_soon', type));
            case OrderStatus.WAITING:
                return t(this.calcTranslationString('Waiting', type));
            case OrderStatus.DRIVING:
                return t(this.calcTranslationString('On_the_way', type));
            case OrderStatus.STATUS_CARE_REQ:
                return t(this.calcTranslationString('Customer_care', type));
            case OrderStatus.PENDING:
            case OrderStatus.RESERVED:
            case OrderStatus.ASSIGNED:
                if (history?.scheduledAt?.seconds) {
                    return this.calcDateString(t, new Date(history.scheduledAt.seconds * miliseconds));
                } else if (eta?.range?.from?.seconds) {
                    return this.calcDateString(t, new Date(eta.range.from.seconds * miliseconds));
                }
                return '';
            case OrderStatus.COMPLETED:
                return t(this.calcTranslationString('Completed', type));
            default:
                return t(this.calcTranslationString('Active_ride', type));
        }
    }

    getChatWithCCUrl(country?: string | null | undefined) {
        var userAgent = navigator.userAgent || navigator.vendor;

        if (country === 'IL' && /iPad|iPhone|iPod/.test(userAgent)) {
            return 'https://b.gett.com/CustomerCare';
        }
        return 'https://b.gett.com/ccglobal';
    }

    onCCClick = (_) => {
        this.props.thunkPushEvent(this.props.token, EventType.EVENT_TYPE_CHAT_WITH_CEXP);
    };

    componentDidMount() {
        const originStopPoint = FindStoppoint(this.props.ride?.stops, StopActionType.STOP_ACTION_PICKUP);
        const destinationStopPoint = FindStoppoint(this.props.ride?.stops, StopActionType.STOP_ACTION_DROP_OFF);

        const origin = originStopPoint?.location?.coordinates
            ? this.convertCoord(originStopPoint.location?.coordinates)
            : new LatLngStatic(0, 0);
        const destination = destinationStopPoint?.location?.coordinates
            ? this.convertCoord(destinationStopPoint.location?.coordinates)
            : null;

        const mapCenter = origin && destination ? this.calcCenter(origin, destination) : origin;
        this.setState({
            mapCenter: mapCenter,
        });
    }

    componentWillReceiveProps(newProps) {
        if (this.props.ride.orderStatus !== newProps.ride.orderStatus) {
            const originStopPoint = FindStoppoint(this.props.ride?.stops, StopActionType.STOP_ACTION_PICKUP);
            const destinationStopPoint = FindStoppoint(this.props.ride?.stops, StopActionType.STOP_ACTION_DROP_OFF);

            let origin = originStopPoint?.location?.coordinates
                ? this.convertCoord(originStopPoint.location?.coordinates)
                : new LatLngStatic(0, 0);
            if (newProps.ride?.routeDetails?.driverLocation) {
                origin = this.convertCoord(newProps.ride.routeDetails.driverLocation);
            }
            const destination = destinationStopPoint?.location?.coordinates
                ? this.convertCoord(destinationStopPoint.location?.coordinates)
                : null;
            const mapCenter = origin && destination ? this.calcCenter(origin, destination) : origin;
            this.setState({
                mapCenter: mapCenter,
            });
        }
    }

    getEtaString(
        eta: IETA | null | undefined,
        history: IChangeHistory | null | undefined,
        status: OrderStatus | null | undefined
    ) {
        if (!eta && !history) {
            return null;
        }
        if (status && EtaUnsupportedStatuses.includes(status)) {
            // Preventing showing ETA in some specific statuses
            return null;
        }
        if (eta?.range && eta.range.from?.seconds && eta.range.to?.seconds) {
            const from = new Date(eta?.range?.from?.seconds * miliseconds);
            const to = new Date(eta?.range?.to?.seconds * miliseconds);
            return `${from.toLocaleTimeString('en-GB', timeOptions)} - ${to.toLocaleTimeString('en-GB', timeOptions)}`;
        }

        if (eta?.minutesLeft) {
            return this.getTime(eta.minutesLeft);
        }

        if (history?.scheduledAt?.seconds) {
            const date = new Date(history?.scheduledAt.seconds * miliseconds);
            return `${date.toLocaleTimeString('en-GB', timeOptions)}`;
        }

        return null;
    }

    getParcelsFromStop(stop: IStop | null | undefined): string[] {
        if (!stop?.actions || stop?.actions.length === 0) {
            return [];
        }

        const res: string[] = [];
        stop?.actions.forEach((element) => {
            if (element.parcel?.name) res.push(element.parcel.name);
        });
        return res;
    }

    generateParcellTextElement(
        element: AddressElement,
        stop: IStop | null | undefined,
        company: ICompany | null | undefined
    ) {
        const parcels = this.getParcelsFromStop(stop);
        element.main = parcels;
        element.secondary = company?.name;
        element.iconType = IconType.Parcell;
    }

    generateAddressElement(
        element: AddressElement,
        stop: IStop | null | undefined,
        rideType: RideType | null | undefined
    ) {
        element.main = stop?.location?.address ? [stop.location?.address] : [''];
        element.note = stop?.location?.note;
        element.iconType = RideType.RIDE_TYPE_SENDER === rideType ? IconType.Up : IconType.Down;
    }

    getAddresTexts(
        origin: IStop | null | undefined,
        destination: IStop | null | undefined,
        rideType: RideType | null | undefined,
        company: ICompany | null | undefined
    ): AddressElement[] {
        const texts: AddressElement[] = [];
        const firstAddressElement: AddressElement = { iconType: IconType.Pickup };
        const lastAddressElement: AddressElement = { iconType: IconType.Dropoff };
        switch (rideType) {
            case RideType.RIDE_TYPE_SENDER:
                origin && this.generateAddressElement(firstAddressElement, origin, rideType);
                destination && this.generateParcellTextElement(lastAddressElement, destination, company);
                break;

            case RideType.RIDE_TYPE_RECIPIENT:
                origin && this.generateParcellTextElement(firstAddressElement, destination, company);
                destination && this.generateAddressElement(lastAddressElement, destination, rideType);
                break;

            default:
                firstAddressElement.main = origin?.location?.address ? [origin.location?.address] : [''];
                lastAddressElement.main = destination?.location?.address ? [destination.location?.address] : [''];
                break;
        }
        texts.push(firstAddressElement, lastAddressElement);
        return texts;
    }

    shouldShowDriver(orderStatus: OrderStatus | null | undefined) {
        if (!orderStatus) {
            return false;
        }
        return [OrderStatus.DRIVING, OrderStatus.WAITING, OrderStatus.CONFIRMED, OrderStatus.COMPLETED].includes(
            orderStatus
        );
    }

    render() {
        const {
            routeDetails,
            driver,
            orderStatus,
            rideStartPinCode,
            changeHistory,
            country,
            division,
            stops,
            type,
            company,
            canceledBy,
            isMeetAndGreet,
            pickupInstructions,
            isShareRide,
        } = this.props.ride;

        const originStopPoint = FindStoppoint(stops, StopActionType.STOP_ACTION_PICKUP);
        const destinationStopPoint = FindStoppoint(stops, StopActionType.STOP_ACTION_DROP_OFF);

        const pickup = originStopPoint?.location?.address;
        const dropoff = destinationStopPoint?.location?.address;

        // eslint-disable-next-line

        const { t } = this.props;

        const statusMessage = this.getStatusMessage(
            t,
            changeHistory,
            OrderStatus[OrderStatus[orderStatus!]],
            type,
            canceledBy,
            routeDetails?.eta,
            !!routeDetails?.isUntrackble
        );

        const etaString = this.getEtaString(routeDetails?.eta, changeHistory, OrderStatus[OrderStatus[orderStatus!]]);

        const addressTexts = this.getAddresTexts(originStopPoint, destinationStopPoint, type, company);

        const isDriverShown = this.shouldShowDriver(OrderStatus[OrderStatus[orderStatus!]]);

        const ccURL = this.getChatWithCCUrl(country);

        return (
            <div>
                <LogoContainer>
                    <LogoImg src={gettLogo} alt='Logo' />
                </LogoContainer>
                <Map ride={this.props.ride} token={this.props.token} />
                <BottomContainer>
                    {etaString && <Eta eta={etaString} />}
                    {statusMessage && (
                        <Status
                            isPartial={routeDetails?.isUntrackble!}
                            message={statusMessage}
                            orderStatus={OrderStatus[OrderStatus[orderStatus!]]}
                        />
                    )}
                    {isMeetAndGreet && pickupInstructions && <MeetAndGreet message={pickupInstructions} />}
                    {(driver || division) && isDriverShown && (
                        <Fragment>
                            <DriverDetailesContainer
                                {...driver}
                                divisionName={division?.name}
                                orderStatus={orderStatus}
                                rideStartPinCode={rideStartPinCode}
                                isShareRide={isShareRide}
                            ></DriverDetailesContainer>
                            <div style={{ margin: '0 23px' }}>
                                <DividerWrapper />
                            </div>
                        </Fragment>
                    )}
                    {(pickup || dropoff) && <Address addreses={addressTexts} />}
                    <CompanyLogo />
                    <a href={ccURL} onClick={this.onCCClick}>
                        <ButtonContainer>{t('common:Report_problem')}</ButtonContainer>
                    </a>
                </BottomContainer>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({});

export default withTranslation(['status', 'common'])(connect(mapStateToProps, { thunkPushEvent })(TrackingWrapper));

type CompanyLogoProps = {
    // For the Phase 2
    //img?: number
};

const CompanyLogoContainer = styled.div`
    padding: 0 25px 22px 25px;
    display: flex;
    flex-direction: column;
    color: #808080;
    font-size: 14px;
`;

const CompanyLogo = (initial: CompanyLogoProps) => {
    return (
        <CompanyLogoContainer>
            <div>Powered by</div>
            <img src={gettLogo} alt='GettLogo' style={{ width: '60px' }} />
        </CompanyLogoContainer>
    );
};
